import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-draw1-blue",
  "use": "icon-draw1-blue-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-draw1-blue\"><path d=\"M98 607.49v132.16h130.42l391.27-396.46-130.42-132.15L98 607.49z m619.5-429.5l-65.21-66.07c-18-18.24-47.2-18.24-65.2 0l-32.6 33.04 130.42 132.15 32.61-33.05c8.65-8.76 13.5-20.65 13.5-33.04-0.01-12.38-4.87-24.27-13.52-33.03zM98 833.1h830v93.44H98V833.1z m0 0\" p-id=\"14593\" fill=\"#1296db\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol